import { Guid } from "guid-typescript";

export class PaymentAccount {
    id: string;
    name?: string;
    code: string;
    // Human-readable account code for display (Xero code / QBO AcctNum).
    // `code` is the internal id for QBO and is relied on by supplier
    // default-account matching, so it must not be used for display.
    displayCode?: string;
    accountID:string;
    checked?: boolean;
    isActive?: boolean;
    /** Organisation/GetBankAccountDetails: the account's kind (bank, credit card, ...) and number,
     *  for the bank/card icon and the "Credit card · •••• 1234" line in account pickers. */
    bankAccountType?: string;
    bankAccountNumber?: string;

    constructor() {
        this.id = Guid.EMPTY;
        this.name = '';
        this.code = '';
        this.isActive = true;
    }
}